<template>
    <div style="width:100%">
      <Loading :value="loading"></Loading>
      <!-- RACOURCIS -->
      <v-card>
        <v-card-title style="padding: 0px">
          <v-layout row>
            <v-flex sm6>
              <v-breadcrumbs icons divider="chevron_right">
                <v-breadcrumbs-item>REVUE BUDGETAIRE</v-breadcrumbs-item>
              </v-breadcrumbs>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
      <br />
      <!-- RECHERCHER DES FACTURES -->
      <el-row :gutter="10">
        <div class="grid-content" style="padding:3px; margin:20px;">
          <v-layout row class="elevation-12 pt-1 mb-3">
                  <v-flex xs12 class="text-xs-center">
                        <h3>Critères de recherche </h3>
                        <v-divider class="mb-2"></v-divider>
                          <el-form :inline="true" :model="formTri" id="formTri" class="demo-form-inline">

                              <el-form-item label="Projet" width="400 px">
                                  <el-select v-on:change="onchangeInfo(selectProjet)" filterable clearable v-model="selectProjet" placeholder="Projet">
                                      <el-option
                                              v-for="item in listeProjet"
                                              :key="item.id"
                                              :label="item.libelle"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>
                              </el-form-item> 

                              <el-form-item label="Chantier" md6>
                                  <el-select clearable multiple v-model="selectChantier" placeholder="Chantier">
                                      <el-option
                                              v-for="item in listeChantier"
                                              :key="item.value"
                                              :label="item.libelle"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>
                              </el-form-item>

                              <el-form-item label="Année" >
                                    <el-date-picker
                                      type="month"
                                      placeholder="Choisir une  année"
                                      format="MM-yyyy"
                                      v-model="selectAnnee"  
                                      style="width: 100%;"
                                    ></el-date-picker>
                                </el-form-item>
                              <el-form-item label="">
                                  <v-tooltip bottom>
                                      <v-btn @click="recherche()" slot="activator" class="white--text" color="blue" fab small>
                                          <v-icon>search</v-icon>
                                      </v-btn>Effectuer une recherche
                                  </v-tooltip>
                              </el-form-item>
                          </el-form>
                    </v-flex>
                </v-layout>
        </div>
      </el-row>

<!-- 
      <el-row
      :gutter="20"
      >
        <v-container fluid grid-list-md>
          <v-layout row justify>
            <v-flex md12>
              <div
                id="chartAllBilanRevueBudgetaire"
                style="width: 100%; height: 300px"
              ></div>
            </v-flex>
          </v-layout>
        </v-container>
      </el-row> -->


      <v-card>
        <v-chip text-color="white" label color="primary">
        ETAT D’AVANCEMENT <v-icon right>local_convenience_store</v-icon>
        </v-chip>
        <br>
        <h1 align="center">DETAIL DE REPARTITION PAR CHANTIER</h1>
        <div style="margin: 50px;">
            <el-table :data="tableEtat" :header-cell-style="{ background: '#faae7b',color: 'black'}">
                <el-table-column id="title" prop="num" label="N°" width="50" style="color: orange" />
                <el-table-column id="title" prop="libChantier" align="center" label="DESIGNATIONS" width="200" />
                <el-table-column prop="qte" label="QUANTITES"  align="center" width="150" />
                <el-table-column label="MARCHE DE BASE" align="center">
                    <el-table-column  prop="portion" label="Proportion (%)"  align="center" width="150" />
                    <el-table-column prop="extimation" label="Montant"  align="center" width="150" />
                </el-table-column>
                <el-table-column label="TAUX D'EXECUTION" align="center">
                    <el-table-column prop="tauxExecutP" label="Précédent" align="center" width="122" />
                    <el-table-column prop="tauxExecutA" label="Réalisé" align="center" width="122" />
                    <el-table-column prop="tauxTotal" label="Cumulé" align="center" width="122" />
                </el-table-column>
                <el-table-column label="MONTANT DES TRAVAUX EXECUTES" align="center">
                    <el-table-column prop="mntTrvxP" label="Précédent" align="center" width="122" />
                    <el-table-column prop="mntTrvxA" label="Réalisé" align="center" width="122" />
                    <el-table-column prop="mntTrvxTotal" label="Cumulé" align="center" width="122" />
                </el-table-column>            
            </el-table>
        </div>
        <br><br>
      </v-card><br><br>

      <v-card>
        <v-chip text-color="white" label color="primary">
            MATRICE DE SUIVI DETAILLEE DU <v-icon right>local_convenience_store</v-icon>
        </v-chip>
        <h1 align="center">MATRICE DE SUIVI BUDGETAIRE MENSUEL PAR LOT DU MOIS : {{selectAnneeFormat}}</h1>        
        <div style="margin: 50px;">
          <el-table :data="tableMatrix" :border="true" style="width: 100%">
              <el-table-column type="expand">
                <template #default="props">
                  <div m="4">                   
                    <el-table :data="props.row.travaux" :header-cell-style="{ background: '#faae7b',color: 'black'}">
                      <el-table-column prop="num" label="N°" width="50" />
                        <el-table-column prop="libelle" label="DESIGNATIONS" align="center" width="250" />
                        <el-table-column prop="debourser" label="DEBOURSE SEC" width="220" align="center" />
                        <el-table-column label="PREVISIONNEL (A)" align="center">
                            <el-table-column prop="tauxExecut" align="center" label="Taux d'execution (%)" width="150" />
                            <el-table-column prop="montantPrevisione" align="center" label="Montant TTC en FCFA" width="150" />
                        </el-table-column>
                        <el-table-column label="DEPENSES (B)" align="center">
                            <el-table-column prop="tauxDepense" align="center" label="Taux d'execution (%)" width="150" />
                            <el-table-column prop="montantDepense" align="center" label="Montant TTC en FCFA" width="150" />
                        </el-table-column>
                        <el-table-column label="ECART ( A -B)" align="center">
                            <el-table-column prop="tauxEcart" align="center" label="Taux d'execution" width="150" />
                            <el-table-column prop="montantEcart" align="center" label="Montant TTC en FCFA" width="162" />
                        </el-table-column> 
                    </el-table>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="N°" />
              <el-table-column label="LOT" prop="libChantier" />
            </el-table>      
        </div><br><br>
      </v-card><br><br>

      <!-- <v-card>
        <v-chip text-color="white" label color="primary">
            RECAPITULATIF DES BESIONS <v-icon right>local_convenience_store</v-icon>
        </v-chip>
       
        <h1 align="center">SUIVI DES STOCKS</h1>
        <div style="margin: 50px;">
            <el-table :data="tableEtat" :header-cell-style="{ background: '#faae7b',color: 'black'}">
                <el-table-column prop="num" label="NC" width="50" align="center" />
                <el-table-column prop="lots" label="LOTS" width="70" align="center"  />
                <el-table-column prop="designation" label="DESIGNATION" width="220" align="center" />
                <el-table-column prop="unite" label="UNITE" width="70" align="center" />
                <el-table-column label="Stock Fin Novembre" center align="center">
                    <el-table-column prop="entreeNov" label="ENTREE" width="150" />
                    <el-table-column prop="sortieNov" label="SORTIE" width="150" />
                    <el-table-column prop="stockAncienNo" label="STOCK ANCIEN" width="150" />
                </el-table-column>
                <el-table-column label="Dépenses Decembre 2021" width="100%" align="center">
                    <el-table-column prop="tauxDepense" label="ENTREE" width="150" />
                    <el-table-column prop="montantDepense" label="SORTIE" width="150" />
                    <el-table-column prop="montantDepense" label="STOCK ANCIEN" width="150" />
                </el-table-column>
                <el-table-column label="TOTAL" width="100%" align="center">
                    <el-table-column prop="entreeTotal" label="ENTREE + EXISTANT" width="150" />
                    <el-table-column prop="sortieTotal" label="SORTIE" width="150" />
                    <el-table-column prop="stockTotal" label="STOCK" width="150" />
                </el-table-column>
            </el-table>
        </div><br><br>
      </v-card><br><br> -->
    </div>
    

  </template>
  
  <script>
    var echarts = require("echarts/lib/echarts");
  require("echarts/lib/chart/bar");
  require("echarts/lib/chart/line");
  require("echarts/lib/chart/pictorialBar");
  require("echarts/lib/chart/funnel");
  require("echarts/lib/chart/sankey");
  require("echarts/lib/chart/scatter");
  require("echarts/lib/chart/pie");
  require("echarts/lib/component/tooltip");
  require("echarts/lib/component/title");

  import ModalRevueBudgetaire from '@/components/projet/ModalRevue/ModalRevueBudgetaire'
  import Loading from "@/components/Loading";
import { white } from 'color-name';
  export default {
    components: { 
      Loading,
      ModalRevueBudgetaire,
     },
    name: "search",
    props: {
      show: {
        type: Boolean
      },
      detailChantier: {
        type: Object
      }
    },
    data() {
      return {
        domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
        user: JSON.parse(sessionStorage.getItem('userInfo')),
        roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
        droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
        loading: false,
        listResulat: [],
        typeRech: '',
        valuetypeRech: '',
        formDmd: {
            chantier: '',
            autre:'',
            montant:5,
            demandeur:'',
            motif:'',
            projet:'',
            caisseSelect:'',
            },
  
        //ONGLET TRAVAUX
        detailTravaux: {},
        dialogConfirmRefus: false,
        showRapport: false,
        showListeRapport: false,
        dialogListeRapport: false,
        dialogShowLivraison: false,
        dialogShowFacture: false,
        dialogShowCommande: false,
        dialogAide: false,
        valid: true,
        optionLivr: [],
        detailBudget: null,
        detailLivraison: [],
        fichierProj: [],
        listeProjet:[],
        reloading:[],
        listeChantier:[],
        tableEtat: [],
        tableBesion: [],
        tableMatrix: [],
        showBoat: false,
        showConteneurs: false,
        totComLigneTTC: 0,
        nomFourn: '',
        selectProjet: [],
        period: [],
        selectChantier: [],
        listFourn: [],
        showButon: false,
        showButonExcel: true,
  
        listCommande: [],
        idComm: '',
        detailCommande: [],
        livraisonCourant: [],
        commCourant: [],
        listFacture: [],
        factureCourant: [],
        detailFacture: [],
        listeRapports: [],
        periodeFormat: "",
        selectAnnee:'',
        formTri:{periode:'',},
        //ONGLET RESERVE
        listeReserves: [],
        //DASHBOARD TRAVAUX
        formRecherche: {
          commande: '',
          facture: '',
          livraison: ''
        },
        period: {
          periode:null
      }
      };
    },
    methods: {
      loadProjet () {
            let url = this.domaine + 'projet/index-projet-all'
            this.loading = true
            this.$http.get(url).then(response => {
                this.loading = false
                    this.listeProjet = response.body.projet
                    this.reloading = response.body.projet;
                    this.chartAllBilanRevueBudgetaire();
            },errRep=>{
                  this.loading = false
                this.$message.error("Une erreur est survenue lors du chargement de la liste des projets")
            })
            },
            loadChantier (item)
              {
                this.loading =  true
               //this.formDmd.chantier = '';
                let url = this.domaine + 'projet/'+ item +'/index/chantier'
                this.$http.get(url).then(response => {
                    this.loading = false
                    this.listeChantier = response.body.chantier
                    this.listeChantier.length > 0 ? (this.formDmd.chantier == this.listeChantier[0].id ): null
                },errRep=>{
                     this.loading = false
                    this.$message.error("Une erreur est survenue lors du chargement de la liste du chantier")
                })
            },
            computed: {
              desactiveBout: function(){

                  return (this.period.periode == undefined);
              }
            },
            clearSelect(){
              this.listeProjet = this.reloading;
              },
  
            onchangeInfo(idProjet)
           { if(idProjet != ""){
              this.loadChantier(idProjet)
            }
           },
      closeDialog() {
        this.$emit("close");
      },
      headerRowStyle({ row, rowIndex }) {
        return { "color": "black" };
      },

      chartAllBilanRevueBudgetaire() {
      let option = {
        title: {
          text:
            "GRAPHE D'AVANCEMENT PHYSIQUE CUMULE / PAR LOT IMMEUBLES 1 & 3 AU 31 Décembre"
        },
        tooltip: {},
        legend: {
          data: []
        },
        xAxis: {
          type: "",
          data: []
        },
        yAxis: {
          type: ""
        },
        series: [
          {
            data: [],
            type: "bar"
          }
        ]
      };

      this.listeProjet.forEach(function(element) {
        option.xAxis.data.push(element.date);
        option.series[0].data.push(element.montant);
      });

      let myChart = echarts.init(
        document.getElementById("chartAllBilanRevueBudgetaire")
      );
      // use configuration item and data specified to show chart
      myChart.setOption(option);
    },
      getSumm(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Total";
            return;
          }
          if (index === 4) {
            sums[index] = "N/A";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = new Intl.NumberFormat().format(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  let total = prev + curr
                  return Math.round(total);
                } else {
                  return prev;
                }
              }, 0)
            );
          } else {
            sums[index] = "N/A";
          }
        });
  
        return sums;
      },
      imprimerFacture(ligne) {
        let url = this.domaine + 'fournisseur/' + ligne.idFact + '/' + this.user.id + '/imprimer/facture'
        this.$http.get(url).then(response => {
          if (response.body) {
          }
        })
        window.open(url)
      },
      imprimerCommande(ligne) {
        let url = this.domaine + 'fournisseur/' + ligne.id + '/imprimer/commande/' + this.user.id
        this.$http.get(url).then(response => {
          if (response.body) {
          }
        })
        window.open(url)
      },
      imprimerLivraison(ligne) {
        let url = this.domaine + 'fournisseur/' + ligne.id + '/imprimer/livraison/' + this.user.id
        this.$http.get(url).then(response => {
          if (response.body) {
          }
        })
        window.open(url)
      },
      chartsMarqueVeh() {
      var dataAxis = [];
      var data = [];
      var yMax = 500;
      var dataShadow = [];
      for (var i = 0; i < data.length; i++) {
        dataShadow.push(yMax);
      }

      let optionApproEntre = {
        title: {
          text: "STATISTIQUES DU NOMBRE DE VEHICULES ACQUIS PAR AN",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        xAxis: {
          data: [],
          axisLabel: {
            inside: true,
            textStyle: {
              color: "#000"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          z: 10
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#999"
            }
          }
        },
        dataZoom: [
          {
            type: "inside"
          }
        ],
        series: [
          {
            // For shadow
            type: "bar",
            itemStyle: {
              normal: { color: "rgba(0,0,0,0.05)" }
            },
            barGap: "-100%",
            barCategoryGap: "40%",
            data: dataShadow,
            animation: false
          },
          {
            type: "bar",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" }
                ])
              },
              emphasis: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#2378f7" },
                  { offset: 0.7, color: "#2378f7" },
                  { offset: 1, color: "#83bff6" }
                ])
              }
            },
            data: []
          }
        ]
      };
      var zoomSize = 23;

      this.statsMarque.forEach(function(element) {
        optionApproEntre.xAxis.data.push(element);
      });

      this.statsMarqueData.forEach(function(element) {
        optionApproEntre.series[1].data.push(element);
      });

      let chartsMarqueVeh = echarts.init(
        document.getElementById("chartsMarqueVeh")
      );
      chartsMarqueVeh.setOption(optionApproEntre);
    },

      imprimerInfo(row) {
        switch (this.typeRech) {
          case 'commande':
            this.imprimerCommande(row)
            break;
  
          case 'livraison':
            this.imprimerLivraison(row)
            break;
  
          case 'facture':
            this.imprimerFacture(row)
            break;
  
          case 'approvisionnement':
            this.imprimerAppro(row)
            break;
  
          default:
            break;
        }
  
  
      },
      recherche() {
        // this.loading = true
        this.listResulat = [];
        this.showButon = true
        let form = document.getElementById('formTri')
        let data = new FormData(form)
        let url = this.domaine + 'projet/revue'
        data.append("idProjet", this.selectProjet);
        data.append( "date", this.period.periode);
        data.append("idChantier", this.selectChantier);
        let dateSelect = null
          this.selectAnneeFormat = ''         
          if(this.selectAnnee != '') {
            let tabDFin = new Intl.DateTimeFormat('en-GB').format(this.selectAnnee).split("/")
            dateSelect = tabDFin[2]+'-'+tabDFin[1]
            this.selectAnneeFormat = tabDFin[2]+'-'+tabDFin[1]
          }else {
            var ladate=new Date()
            this.selectAnneeFormat = (ladate.getMonth()+1)+'-'+ladate.getFullYear()
          }
        data.append('annee', dateSelect)
        this.$http.post(url, data).then(response =>{          
          this.tableEtat = response.body[0].etatAvancement;
          this.tableMatrix = response.body[0].matrice;
          console.log('tableEtat',this.tableEtat)
          console.log('tableMatrix',this.tableMatrix)
          // this.loading = false;
        })
      },
    },
    mounted() {
      this.loadProjet()
    },
    computed: {
      desactiveBout: function () {
  
        return (this.period.periode == undefined);
      }
    },
    
    
  
  };
  </script>


// WEBPACK FOOTER //
// src/components/Projet/RevueBudgetaire.vue